import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';

import { useCancelBonus } from 'js/components/main/BonusHistory/hooks/useCancelBonus';

export const useCancelBonusPopup = () => {
    const dispatch = useDispatch();
    const translate = useComponentTranslations();
    const cancelBonus = useCancelBonus();

    return useCallback((event: React.MouseEvent<HTMLElement>, bonusName: string, bonusInstanceCode: string): void => {
        event.preventDefault();
        event.stopPropagation();

        const content = bonusName === '' ?
                translate('playtech.mobile.system.balance.removeBonusMessageDefault') :
            translate('playtech.mobile.system.balance.removeBonusMessage', [bonusName]);

            dispatch(showConfirmationPopupAction({
            isModal: true,
            title: translate('playtech.mobile.system.balance.removeBonusTitle'),
            onAccept: () => cancelBonus(bonusInstanceCode),
            acceptBtnText: translate('playtech.mobile.system.message.accept'),
            declineBtnText: translate('playtech.mobile.system.message.decline'),
            content
        }));
    }, [cancelBonus, dispatch, translate]);
};
